import React from 'react'
import './FinalMessage.css'

const FinalMessage = ({ userName }) => {
    return <div className="final-message">Congratulations {userName} !</div>
}

export default FinalMessage
